import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { PtsDocumentModal } from '../../components/pts_document_modal';
import { invalidateSignedDocumentQueries } from '../../utils/invalidate_signed_document_queries';
import { isPtsDocument } from '../site_document_details.helpers';
/**
 * Replaces the signed wet-ink PDF on a completed printed document. File-only PUT —
 * the completion date is left alone. No-PII sites and voided/cancelled documents
 * never get the control.
 */
export const useReplacementUploadAction = ({ apiClient, accountId, getApiErrorMessage, canModifyDocument = true, isNoPiiSite = false, }) => {
    const queryClient = useQueryClient();
    const [selectedDocument, setSelectedDocument] = useState(null);
    const canReplaceSignedCopy = useCallback((candidate) => canModifyDocument && !isNoPiiSite && isPtsDocument(candidate) && candidate?.ec__status === 'complete', [canModifyDocument, isNoPiiSite]);
    const openReplacementUpload = useCallback((candidate) => {
        if (canReplaceSignedCopy(candidate)) {
            setSelectedDocument(candidate);
        }
    }, [canReplaceSignedCopy]);
    const closeReplacementUpload = useCallback(() => setSelectedDocument(null), []);
    const replacementUploadModal = useMemo(() => selectedDocument && apiClient
        ? createPortal(_jsx(PtsDocumentModal, { isOpen: true, replacementUploadMode: true, onClose: closeReplacementUpload, signedDocId: selectedDocument._id, status: selectedDocument.ec__status, signatureDate: selectedDocument.ec__pts_signature_date_wallclock, finalDocumentUrl: selectedDocument.ec__final_document?.url, accountId: accountId, isNoPiiSite: isNoPiiSite, apiClient: apiClient, getApiErrorMessage: getApiErrorMessage, onComplete: () => {
                invalidateSignedDocumentQueries(queryClient, { documentId: selectedDocument._id });
                closeReplacementUpload();
            } }), document.body)
        : null, [accountId, apiClient, closeReplacementUpload, getApiErrorMessage, isNoPiiSite, queryClient, selectedDocument]);
    return { canReplaceSignedCopy, openReplacementUpload, replacementUploadModal };
};
